import { color, isSpace, Text } from '@starrez/starryui9';
import * as React from 'react';
import styled from 'styled-components';
import { Spinner } from '../../Loading/Spinner';
import { ToggleSwitch, ToggleSwitchBar } from './ToggleSwitch';

export interface IToggleSwitchWithLabelProps {
    defaultValue?: boolean;
    onClick?: (value: boolean) => Promise<void> | void;
    caption: string;
    ariaLabel: string;
}

export interface IToggleSwitchStatus {
    isSelected: boolean;
}

export const ToggleSwitchWithLabel = ({ caption, defaultValue, ariaLabel, onClick }: IToggleSwitchWithLabelProps) => {
    const [isSelected, setSelected] = React.useState(defaultValue ? defaultValue : false);
    const [isLoading, setLoading] = React.useState(false);

    const handleOnClick = () => {
        const value = !isSelected;
        if (onClick) {
            setLoading(true);
            setSelected(value);
            Promise.resolve(onClick(value))
                .catch((error) => {
                    throw error;
                })
                .finally(() => setLoading(false));
        } else {
            setSelected(value);
        }
    };

    const handleOnKeyUp = (e: React.KeyboardEvent<HTMLButtonElement>) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (isSpace(e as any)) {
            handleOnClick();
        }
    };

    return (
        <ToggleSwitchWithLabelWrapper
            onClick={handleOnClick}
            onKeyUp={handleOnKeyUp}
            aria-label={ariaLabel}
            aria-checked={isSelected}
            aria-busy={isLoading}
            type="button"
            role="switch"
        >
            <LabelWrapper isSelected={isSelected}>{isLoading ? <Spinner /> : <Text variant="normal.bold">{caption}</Text>}</LabelWrapper>
            <ToggleSwitch isSelected={isSelected} />
        </ToggleSwitchWithLabelWrapper>
    );
};

const LabelWrapper = styled.span<IToggleSwitchStatus>`
    color: ${(p) => (p.isSelected ? color.Blue.B60 : 'inherit')};
    width: 136px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const ToggleSwitchWithLabelWrapper = styled.button`
    display: inline-flex;
    gap: 8px;
    border: 0;
    background: transparent;
    height: 48px;
    align-items: center;
    outline: none;
    cursor: pointer !important;

    * {
        cursor: pointer !important;
    }

    &:focus ${ToggleSwitchBar} {
        box-shadow: 0px 0px 0px 2px ${color.Blue.B80};
    }

    &:hover ${ToggleSwitchBar} {
        background: ${color.Blue.B80};
    }

    &:hover ${LabelWrapper} {
        color: inherit;
    }
`;
